import React from 'react';

import '../../i18/config';
import {useTranslation} from "react-i18next";
import {LordIcon} from "../LordIcon";
import {Alert} from "reactstrap";
import CodeConfirmation from "../CodeConfirmation";

interface ConfirmationBlockProps {
    timerDuration: number;
    handleSubmit: (code: string) => void;
    onResendConfirmation: () => void;
    handleCancel: () => void;
    error?: string;
}


const ConfirmationBlock = ({timerDuration, handleSubmit, handleCancel, onResendConfirmation, error = ''} : ConfirmationBlockProps) => {

    const { t } = useTranslation(['auth']);

    return (
        <>
            <div className="mt-2 text-center">
                <LordIcon
                    src="https://cdn.lordicon.com/edcgvlnw.json"
                    trigger="loop"
                    colors={{primary: '#0ab39c', secondary: '#32b67d'}}
                    size={120}
                />
            </div>
            <Alert className="alert-borderless alert-info text-center mb-4" role="alert">
                {t('auth:confirmationCodeNotice')}!
            </Alert>

            {error && error.length > 0 &&
                <div className="mb-4 text-center">
                    <Alert className="alert-borderless alert-warning text-center mb-2"
                           role="alert">
                        {t('auth:' + error)}!
                    </Alert>
                </div>
            }
            <CodeConfirmation
                cancelButtonText={t('common:cancel')}
                handleCancel={handleCancel}
                showCancelButton={false}
                onChange={handleSubmit}
                timerDuration={30}
                onResendConfirmation={onResendConfirmation}
            />
        </>
    );
};

export default ConfirmationBlock;